import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import { Alert, AlertDescription } from 'components/ui/alert';
import { ACTIVE, fmtMs, fmtUsd } from './util';

export default function RunProgress({ run, label = 'Working', children }) {
  if (!run) return null;
  if (ACTIVE.has(run.status)) {
    return (
      <div className="flex items-center gap-3 rounded-md border border-borderGrey bg-muted/30 px-3 py-2">
        <Loader2 size={18} className="animate-spin text-primary" />
        <div className="text-token-base">
          <div className="font-medium">{label}</div>
          <div className="text-muted-foreground">{run.progress || 'Starting…'}</div>
        </div>
      </div>
    );
  }
  if (run.status === 'failed') {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          <div className="font-medium">This step failed</div>
          <div className="mb-2 whitespace-pre-wrap text-token-base">{run.error}</div>
          {children}
        </AlertDescription>
      </Alert>
    );
  }
  return (
    <p className="text-token-base text-muted-foreground">
      Done in {fmtMs(run.latency_ms)} · {run.model || '–'} · {run.input_tokens ?? '–'} in / {run.output_tokens ?? '–'} out
      {run.cache_read_tokens ? ` (${run.cache_read_tokens} cached)` : ''} · {fmtUsd(run.cost_usd)}
    </p>
  );
}
